import api from 'services/api';
import { IParamsGetBachAPI } from '../types';

export const getBachsAPI = (params?: IParamsGetBachAPI) => {
  console.log(params);

  return api.patch('Relatorio/ArmazenagemEstoque/SaidaLote', {
    ...params,
  });
};

export const handleOptionsEstructure = (clientId: string) =>
  api.get(`Common/TipoPedido?CodigoCliente=${clientId}`);
